export default function uid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (
  // eslint-disable-next-line no-bitwise
    c
    // eslint-disable-next-line no-bitwise
            ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
  ).toString(16));
}
